import {OFFER_3D_VIEWS} from "../constants/offer_3d_views";

const offer3dViewIds = OFFER_3D_VIEWS.map((view) => view.id);

export const hasOffer3dView = (offer: {id?: number} | null | undefined): boolean => offer?.id != null && offer3dViewIds.includes(offer.id);

export const getOffer3dViewLink = (offerId: number): string | undefined => Object.values(OFFER_3D_VIEWS).find((view) => view.id === offerId)?.link;
import {OFFER_3D_VIEWS} from "../constants/offer_3d_views";

const offer3dViewIds = OFFER_3D_VIEWS.map((view) => view.id);

export const hasOffer3dView = (offer: {id?: number} | null | undefined): boolean => offer?.id != null && offer3dViewIds.includes(offer.id);

export const getOffer3dViewLink = (offerId: number): string | undefined => Object.values(OFFER_3D_VIEWS).find((view) => view.id === offerId)?.link;
